import {
  IconDefinition,
  faCity,
  faLeaf,
  faMedal,
  faTree,
  faTreeCity,
} from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Tag } from '.';
import { Intent } from '../types';
import classNames from '../utilities/class-names';

type SubscriptionTagStyle = {
  icon: IconDefinition;
  className: string;
  label: string;
  intent?: Intent;
};

const subscriptionTagStyles: {
  [key: string]: SubscriptionTagStyle;
} = {
  free: {
    icon: faLeaf,
    className: 'subscription-tag-free',
    label: 'Free',
    intent: 'info',
  },
  indie: {
    icon: faTree,
    className: 'subscription-tag-indie',
    label: 'Indie',
    intent: 'success',
  },
  pro: {
    icon: faTreeCity,
    className: 'subscription-tag-pro',
    label: 'Pro',
    intent: 'warning',
  },
  scale: {
    icon: faCity,
    className: 'subscription-tag-scale',
    label: 'Scale',
    intent: 'danger',
  },

  // Retired plans. Accounts can still hold these ids, and the tag has to
  // render something rather than throwing.
  developer: {
    icon: faTree,
    className: 'subscription-tag-developer',
    label: 'Developer',
    intent: 'success',
  },
  enterprise: {
    icon: faTreeCity,
    className: 'subscription-tag-enterprise',
    label: 'Enterprise',
    intent: 'warning',
  },
  unlimited: {
    icon: faMedal,
    className: 'subscription-tag-unlimited',
    label: 'Unlimited',
    intent: 'warning',
  },
};

const unknownSubscriptionTagStyle: SubscriptionTagStyle = {
  icon: faMedal,
  className: 'subscription-tag-unknown',
  label: 'Unknown',
};

type SubscriptionTagProps = {
  subscription: string;
};

export function SubscriptionTag({
  subscription,
}: SubscriptionTagProps): ReactElement {
  const { icon, className, label, intent } =
    subscriptionTagStyles[subscription] ?? unknownSubscriptionTagStyle;

  return (
    <Tag
      show
      className={classNames('subscription-tag', className)}
      icon={icon}
      intent={intent}
    >
      {label}
    </Tag>
  );
}
